





















import Vue from 'vue';
import TIcons from '@/types/TIcons';

interface IButtonWithArrowHoverAnimationComponent {
  arrowRightWild: string;
}

export default Vue.extend({
  name: `ButtonWithArrowHoverAnimation`,
  data(): IButtonWithArrowHoverAnimationComponent {
    return {
      arrowRightWild: TIcons.arrowRightWild,
    };
  },
  props: {
    iconLabel: {
      default: null,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
  },
});
